module.exports = __webpack_public_path__ + "img/av_horse.5b902952.png";